<template>
<div
    v-if="chips != null && chips.chips.length > 0"
    class="action-container"
>
    <m-action-chip
        icon="mdi-information-slab-circle-outline"
        line1="Notice"
        line2="Beta"
        line3="Development in progress"
    />

    <m-action-chip
        v-for="(item, key) in chips.chips"
        :key="'chip_'+key"
        :state="item.chip_state"
        :icon="item.icon"
        :line1="item.line1"
        :line2="item.line2"
        :line3="item.line3"
        :clickable="isClickable(item)"
        v-on:click="onClick(item)"
    />

    <m-dialog-conversation-chip-recent-shipments
        ref="dialog-shipments"
    />

</div>
</template>

<script>
export default {
    props: {
        organization_id: {
            type: String,
            default: function() { return null; }
        },

        conversation_id: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            last_conversation_id: null,
            chips: null,
        }
    },

    mounted () {
        this.loadChips();
    },

    methods: {
        loadChips() {
            if ( this.conversation_id == null )
            {
                this.chips = null;
                return;
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/conversation/chips/:conversation_id',
            
                'params' : {
                        'conversation_id': this.conversation_id,
                    },
            
                'on_success': (data) => {
                        this.chips = data;

                        if ( this.chips != null && this.chips.chips.length > 0 )
                        {
                            window.setTimeout(() => {this.$emit('scroll-to-bottom');}, 100);
                            window.setTimeout(() => {this.$emit('scroll-to-bottom');}, 250);
                            window.setTimeout(() => {this.$emit('scroll-to-bottom');}, 500);
                        }
                    },
            
                'on_error': () => {},
            });
        },

        onClickBeta()
        {
            this.$rc.alert('Beta Features: App Actions in Conversations', 'Integration conversation actions are in Beta test.<br/><br/>Please confirm the information displayed before relying upon it.');
        },

        isClickable(item)
        {
            return item.on_click_url != null || item.shipments.length > 0;
        },

        onClick(item)
        {
            if ( item.on_click_url != null )
            {
                window.open(item.on_click_url, '_blank');
                return;
            }

            if ( item.shipments.length > 0 )
            {
                this.$refs['dialog-shipments'].showDialog(item.shipments);
                return;
            }
        }
    },

    watch: {
        conversation_id: function(new_value)
        {
            if ( new_value == null ) 
                return;

            if ( this.last_conversation_id == new_value )
                return;

            this.last_conversation_id = new_value;
            this.loadChips();
        },
    },
}
</script>

<style lang="scss" scoped>
.action-container
{
    display: flex; 
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
}
</style>